import { ReactNode } from "react";

import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Tab from "ds/components/Tab";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import Box from "ds/components/Box";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";

type UsageLayoutHeaderProps = {
  title: string;
  children?: ReactNode;
};

const UsageLayoutHeader = ({ title, children }: UsageLayoutHeaderProps) => {
  return (
    <PageInfoHeaderWrapper align="start">
      <Box direction="column">
        <PageInfoHeaderTitle title={title} />

        <ViewHeaderNavigation>
          <Tab to="../workers" label="Workers" />
          <Tab to="../runs" label="Runs" />
        </ViewHeaderNavigation>
      </Box>

      <PageInfoHeaderActions>{children}</PageInfoHeaderActions>
    </PageInfoHeaderWrapper>
  );
};

export default UsageLayoutHeader;
